import { Stack } from '@mui/material';
import { Tag, Typography, Badge } from '@sweep-io/sweep-design';
import sum from 'lodash/sum';
import { ListElementWrapper } from '../shared/ListElementWrapper';
import { TagRow } from './types';
import { selectCountSummaryByCrmOrgId } from '../../../reducers/documentation/userInputsReducer';
import { useSelector } from 'react-redux';
import { SubPageTypes } from '../types';
import { useCallback } from 'react';
import { DataTableRow } from '../../common/table/TableTypes';
import { useTags } from '../salesforce-documentation-card/annotations/tags/useTags';

interface TagCenterCardProps {
  item: TagRow;
  crmOrgId: string;
  pageType: SubPageTypes;
}

export const TagCenterCard = ({ item, pageType, crmOrgId }: TagCenterCardProps) => {
  const { onTagClick } = useTags(crmOrgId);
  const onCardClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>, card: DataTableRow) => {
      onTagClick(event, { value: card.value, label: card.label, tagColor: card.color }, true);
    },
    [onTagClick],
  );
  const countSummary = useSelector(selectCountSummaryByCrmOrgId(crmOrgId));
  const displayTag = pageType === SubPageTypes.tags;
  return (
    <Stack width="100%">
      <ListElementWrapper
        isActive={item.isRowActive}
        key={item.id}
        onWrapperClick={(event) =>
          onCardClick(event, {
            value: item.id,
            label: item._name,
            tagColor: item.color,
          } as any)
        }
        leftContent={
          <Stack p={2} pl={0} pr={0} direction="row" justifyContent="space-between" width="100%">
            {displayTag ? (
              <Tag label={item._name} color={item.color} size="medium" />
            ) : (
              <Typography variant="body">{item._name}</Typography>
            )}
            <Badge
              label={
                sum(Object.values(countSummary?.[item.id] ?? {}).map((value) => value.length)) ?? 0
              }
              showZero
              variant="secondary"
            />
          </Stack>
        }
      />
    </Stack>
  );
};
